import React from 'react';
import { LuInbox } from 'react-icons/lu';
import { Text } from '@/components/atoms/AppText';

interface Props {
  colSpan: number;
}

export const EmptyState = ({ colSpan }: Props) => {
  return (
    <tr>
      <td colSpan={colSpan} className="py-20 text-center">
        <div className="flex flex-col items-center gap-3 text-gray-400 dark:text-gray-500">
          {/* Inbox / no-data icon */}
          <LuInbox className="h-16 w-16 opacity-50" strokeWidth={1.2} />
          <Text as="p" size="xl" weight="medium" color="muted">
            No records found
          </Text>
          <Text as="p" size="base" color="muted" className="opacity-70">
            Try adjusting your filters or date range
          </Text>
        </div>
      </td>
    </tr>
  );
};
